import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Recuperé mi claridad mental',
  text: 'Después de meses sintiéndome en una neblina constante, finalmente siento que mi mente está afilada y presente de nuevo. Es un alivio inmenso.',
  name: 'Elena S.'
}, {
  quote: 'Vuelvo a reconocer mi cuerpo',
  text: 'Había dejado de mirarme al espejo porque no me reconocía. Esta guía me enseñó a trabajar con mi cuerpo, no contra él. Me siento yo misma otra vez.',
  name: 'Marta R.'
}, {
  quote: 'Duermo profundo por primera vez en años',
  text: 'El descanso reparador cambió todo. Despertar con energía real y no depender de tres cafés para empezar el día no tiene precio.',
  name: 'Claudia M.'
}];
export function Testimonials() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-177">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-179">
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-charcoal)] text-center mb-16" data-id="element-180">
            Historias de transformación
          </h2>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-181">
            {testimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.2
          }} className="bg-[var(--color-cream)] p-10 rounded-2xl flex flex-col h-full" data-id="element-182">
                <div className="flex gap-1 mb-6" data-id="element-183">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-[var(--color-sage)] text-xl" data-id="element-184">
                      ★
                    </span>)}
                </div>
                <h3 className="text-2xl font-bold text-[var(--color-charcoal)] mb-4" data-id="element-185">
                  "{t.quote}"
                </h3>
                <p className="text-base lg:text-lg text-[var(--color-charcoal)] opacity-70 font-light leading-relaxed mb-8 flex-grow" data-id="element-186">
                  {t.text}
                </p>
                <div className="mt-auto" data-id="element-187">
                  <p className="text-base font-medium text-[var(--color-charcoal)] mb-2" data-id="element-188">
                    — {t.name}
                  </p>
                  <p className="text-sm text-[var(--color-charcoal)] opacity-50 font-light italic" data-id="element-189">
                    (Testimonio ilustrativo — los resultados pueden variar)
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}